import { useRootData } from './use-root-data';

/**
 * The region the visitor's connection geolocates to (e.g. "Canterbury"), or
 * null when unknown. Comes from the server because the `__ap_location` cookie
 * is HttpOnly and the browser cannot read it.
 */
export const useVisitorRegion = (): string | null =>
    useRootData()?.visitorRegion ?? null;
